import { request } from "../utils/request.js"


export const customer_exportForManage = (pojo, args) => request({
    url: 'customer/exportForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customer_addNew = (pojo, args) => request({
    url: 'customer/addNew',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})
export const customer_update = (pojo, args) => request({
    url: 'customer/update',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customer_findByPageForManage = (pojo, args) => request({
    url: 'customer/findByPageForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customer_findListForManage = (pojo, args) => request({
    url: 'customer/findListForManage',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customer_findByPageForSelect = (pojo, args) => request({
    url: 'customer/findByPageForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})

export const customer_findListForSelect = (pojo, args) => request({
    url: 'customer/findListForSelect',
    method: 'POST',
    params: pojo,
    showFailMessage: true,
    ...args
})


export const customer_changeFrozenStatus = (id, args) => request({
    url: 'customer/changeFrozenStatus',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    showSuccessMessage: true,
    ...args
})

export const customer_deleteById = (id, args) => request({
    url: 'customer/deleteById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})

export const customer_findById = (id, args) => request({
    url: 'customer/findById',
    method: 'GET',
    params: { id },
    showFailMessage: true,
    ...args
})


// WEBPACK FOOTER //
// ./src/api/customer.js